/* global angular */
( function () {
	'use strict';
	/* eslint-disable max-params */
	function pdfMakerFactory ( pdfMakeProv, pdfCommonFactory, pdStatusReportPdf, templateReportPdf, obsStatusReportPdf, $window, templateGraphPdf ) {
		/* eslint-enable max-params */
		function footerHandler ( currentPage, pageCount ) {
			return {
				'text'      : currentPage.toString() + ' of ' + pageCount,
				'alignment' : 'center',
				'margin'    : [ 0, 10, 0, 0 ]
			};
		}

		function generateStatusPdf ( showDescription, pdList, filters, filename, cb ) {
			var pdfMake = pdfMakeProv();
			var pdf     = {};

			pdf.content = [
				pdStatusReportPdf.generateFrontPage( filters ),
				pdStatusReportPdf.buildReport( showDescription, pdList, filters )
			];

			pdf.styles       = pdfCommonFactory.pdfStyles();
			pdf.pageMargins  = [ 40, 45, 60, 45 ];
			pdf.footer       = footerHandler;
			pdf.defaultStyle = {
				'font' : 'OpenSans'
			};

			pdfMake.fonts = {
				'OpenSans' : {
					'normal'      : 'OpenSans-Regular.ttf',
					'bold'        : 'OpenSans-Bold.ttf',
					'italics'     : 'OpenSans-Italic.ttf',
					'bolditalics' : 'OpenSans-BoldItalic.ttf'
				}
			};

			if ( $window.navigator.platform === 'iPad' ) {
				pdfMake.createPdf( pdf ).open();
				return ( cb || angular.noop )();
			}

			return pdfMake.createPdf( pdf ).download( filename + '.pdf', function () {
				( cb || angular.noop )();
			}  );
		}

		function generateObsStatusPdf ( obsList, filters, filename, cb ) {
			var pdfMake = pdfMakeProv();
			var pdf     = {};

			pdf.content = [
				obsStatusReportPdf.generateFrontPage( filters ),
				obsStatusReportPdf.buildSummaryPage( filters, obsList ),
				obsStatusReportPdf.buildReport( obsList, filters )
			];

			pdf.styles       = pdfCommonFactory.pdfStyles();
			pdf.footer       = footerHandler;
			pdf.pageMargins  = [ 40, 45, 40, 45 ];
			pdf.defaultStyle = {
				'font' : 'OpenSans'
			};

			pdfMake.fonts = {
				'OpenSans' : {
					'normal'      : 'OpenSans-Regular.ttf',
					'bold'        : 'OpenSans-Bold.ttf',
					'italics'     : 'OpenSans-Italic.ttf',
					'bolditalics' : 'OpenSans-BoldItalic.ttf'
				}
			};

			pdfMake.createPdf( pdf ).download( filename + '.pdf', function () {
				( cb || angular.noop )();
			} );
		}

		function generateTemplateGraph ( data, filters, filename, cb, template ) {
			var pdfMake = pdfMakeProv();
			var pdf     = {};

			pdf.content = [
				templateGraphPdf.generateFrontPage( filters ),
				templateGraphPdf.buildReport( data, filters, template )
			];

			pdf.styles       = pdfCommonFactory.pdfStyles();
			pdf.footer       = footerHandler;
			pdf.pageMargins  = [ 40, 45, 40, 45 ];
			pdf.defaultStyle = {
				'font' : 'OpenSans'
			};

			pdfMake.fonts = {
				'OpenSans' : {
					'normal'      : 'OpenSans-Regular.ttf',
					'bold'        : 'OpenSans-Bold.ttf',
					'italics'     : 'OpenSans-Italic.ttf',
					'bolditalics' : 'OpenSans-BoldItalic.ttf'
				}
			};

			pdfMake.createPdf( pdf ).download( filename + '.pdf', function () {
				( cb || angular.noop )();
			} );
		}

		return {
			'generateStatusPdf'     : generateStatusPdf,
			'generateObsStatusPdf'  : generateObsStatusPdf,
			'generateTemplateGraph' : generateTemplateGraph,
			'privateMethods'        : {
				'footerHandler' : footerHandler
			}
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'pdfMakerFactory', pdfMakerFactory );

	pdfMakerFactory.$inject = [ 'pdfMake', 'pdfCommonFactory', 'pdStatusReportPdf', 'templateReportPdf', 'obsStatusReportPdf', '$window', 'templateGraphPdf' ];
} )();
